// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"687":"98bbef0c","7040":"98bbef0c"}[chunkId] + ".chunk.css";
};